'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _index = require('autosuggest-highlight/parse/index');var _index2 = _interopRequireDefault(_index);
var _index3 = require('autosuggest-highlight/match/index');var _index4 = _interopRequireDefault(_index3);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var highlightSuggestion = function highlightSuggestion(suggestion, _ref) {var query = _ref.query;
  if (query.indexOf('״') !== -1) {
    suggestion.address = suggestion.address.replace(/"/g, '״');
  }
  if (query.indexOf('׳') !== -1) {
    suggestion.address = suggestion.address.replace(/'/g, '׳');
  }

  var suggestionText = '' + suggestion.address;
  var formattedQuery = query.replace(/-/g, ' ');
  var matches = (0, _index4.default)(suggestionText, formattedQuery);
  var parts = (0, _index2.default)(suggestionText, matches);

  parts.forEach(function (part, idx) {
    part.id = idx;
  });

  return (
    _react2.default.createElement('div', { className: 'suggestion-field' },
      _react2.default.createElement('span', null,

        parts.map(function (part) {return (
            part.highlight ?
            _react2.default.createElement('strong', { key: 'suggestion_' + part.id }, part.text) :
            _react2.default.createElement('span', { key: 'suggestion_' + part.id }, part.text));}))));





};exports.default =

highlightSuggestion;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/helpers/highlightSuggestion.js
// module id = 1262
// module chunks = 0